import React from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';
import { Search } from '@mui/icons-material';

import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { Tabela } from '~/views/Client/Dashboard/Tabelas';
import { color } from '~/assets/styles/colors';
import { priceFormatter } from '~/helpers/price';

export default function TabelaUltimasVendas(props) {
	const { lista, loading, toggleModalDetalheVenda, handlerUltimaVenda } =
		props;

	function handlerModalUltimaVenda(venda) {
		toggleModalDetalheVenda();
		handlerUltimaVenda(venda);
	}

	function dateSort(a, b) {
		return moment(b.payment_date) - moment(a.payment_date);
	}

	if (loading) {
		return (
			<div
				className="d-flex justify-content-center align-itens-center"
				style={{ height: '418px' }}>
				<LoaderMini width="70" />
			</div>
		);
	}

	if (!loading && lista.length === 0) {
		return <Text>Sem resultados no periodo</Text>;
	}

	return (
		<Tabela>
			<>
				<thead>
					<tr>
						<th className="pt-2">Data</th>
						<th className="pt-2">Valor(R$)</th>
						<th className="pt-2">Titular</th>
						<th className="pt-2" style={{ textAlign: 'center' }}>
							#
						</th>
					</tr>
				</thead>
				<tbody>
					{lista
						.sort(dateSort)
						.slice(0, 9)
						.map((venda) => {
							return (
								<tr
									key={`${moment(venda.payment_date)}-${
										venda.value
									}-${venda.id}`}>
									<td>
										{moment(venda.payment_date).format(
											'DD/MM'
										)}
									</td>
									<td>{priceFormatter(venda.value)}</td>
									{venda.razao_nome.length > 16 ? (
										<td title={venda.razao_nome}>
											{`${venda.razao_nome.substr(
												0,
												16
											)}...`}
										</td>
									) : (
										<td>{venda.razao_nome}</td>
									)}
									<td align="center">
										<div
											role="none"
											className="d-flex justify-content-center"
											onClick={() =>
												handlerModalUltimaVenda(venda)
											}
											style={{
												width: '40px',
												backgroundColor: color.yellow,
												color: color.gray,
												borderRadius: '20px',
												cursor: 'pointer',
											}}>
											<Search />
										</div>
									</td>
								</tr>
							);
						})}
				</tbody>
			</>
		</Tabela>
	);
}

TabelaUltimasVendas.propTypes = {
	lista: PropTypes.oneOfType([PropTypes.array]),
	toggleModalDetalheVenda: PropTypes.func.isRequired,
	handlerUltimaVenda: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
};

TabelaUltimasVendas.defaultProps = {
	lista: [],
};
